export const INDIA_STATE_DISTRICTS: any = {
    "Tamil Nadu": [
        { value: "Ariyalur", label: "அரியலூர் (Ariyalur)" },
        { value: "Chengalpattu", label: "செங்கல்பட்டு (Chengalpattu)" },
        { value: "Chennai", label: "சென்னை (Chennai)" },
        { value: "Coimbatore", label: "கோயம்புத்தூர் (Coimbatore)" },
        { value: "Cuddalore", label: "கடலூர் (Cuddalore)" },
        { value: "Dharmapuri", label: "தருமபுரி (Dharmapuri)" },
        { value: "Dindigul", label: "திண்டுக்கல் (Dindigul)" },
        { value: "Erode", label: "ஈரோடு (Erode)" },
        { value: "Kallakurichi", label: "கள்ளக்குறிச்சி (Kallakurichi)" },
        { value: "Kanchipuram", label: "காஞ்சிபுரம் (Kanchipuram)" },
        { value: "Kanyakumari", label: "கன்னியாகுமரி (Kanyakumari)" },
        { value: "Karur", label: "கரூர் (Karur)" },
        { value: "Krishnagiri", label: "கிருஷ்ணகிரி (Krishnagiri)" },
        { value: "Madurai", label: "மதுரை (Madurai)" },
        { value: "Mayiladuthurai", label: "மயிலாடுதுறை (Mayiladuthurai)" },
        { value: "Nagapattinam", label: "நாகப்பட்டினம் (Nagapattinam)" },
        { value: "Namakkal", label: "நாமக்கல் (Namakkal)" },
        { value: "Nilgiris", label: "நீலகிரி (Nilgiris)" },
        { value: "Perambalur", label: "பெரம்பலூர் (Perambalur)" },
        { value: "Pudukkottai", label: "புதுக்கோட்டை (Pudukkottai)" },
        { value: "Ramanathapuram", label: "ராமநாதபுரம் (Ramanathapuram)" },
        { value: "Ranipet", label: "ராணிப்பேட்டை (Ranipet)" },
        { value: "Salem", label: "சேலம் (Salem)" },
        { value: "Sivagangai", label: "சிவகங்கை (Sivagangai)" },
        { value: "Tenkasi", label: "தென்காசி (Tenkasi)" },
        { value: "Thanjavur", label: "தஞ்சாவூர் (Thanjavur)" },
        { value: "Theni", label: "தேனி (Theni)" },
        { value: "Thoothukudi", label: "தூத்துக்குடி (Thoothukudi)" },
        { value: "Tiruchirappalli", label: "திருச்சிராப்பள்ளி (Tiruchirappalli)" },
        { value: "Tirunelveli", label: "திருநெல்வேலி (Tirunelveli)" },
        { value: "Tirupathur", label: "திருப்பத்தூர் (Tirupathur)" },
        { value: "Tiruppur", label: "திருப்பூர் (Tiruppur)" },
        { value: "Tiruvallur", label: "திருவள்ளூர் (Tiruvallur)" },
        { value: "Tiruvannamalai", label: "திருவண்ணாமலை (Tiruvannamalai)" },
        { value: "Tiruvarur", label: "திருவாரூர் (Tiruvarur)" },
        { value: "Vellore", label: "வேலூர் (Vellore)" },
        { value: "Viluppuram", label: "விழுப்புரம் (Viluppuram)" },
        { value: "Virudhunagar", label: "விருதுநகர் (Virudhunagar)" }
    ],

    "Kerala": [
        { value: "Alappuzha", label: "அலப்புழா (Alappuzha)" },
        { value: "Ernakulam", label: "எர்ணாகுளம் (Ernakulam)" },
        { value: "Idukki", label: "இடுகி (Idukki)" },
        { value: "Kannur", label: "கண்ணூர் (Kannur)" },
        { value: "Kasaragod", label: "காசர்கோடு (Kasaragod)" },
        { value: "Kollam", label: "கொள்ளம் (Kollam)" },
        { value: "Kottayam", label: "கோட்டயம் (Kottayam)" },
        { value: "Kozhikode", label: "கோழிக்கോട് (Kozhikode)" },
        { value: "Malappuram", label: "மலப்புரம் (Malappuram)" },
        { value: "Palakkad", label: "பாலக்காடு (Palakkad)" },
        { value: "Pathanamthitta", label: "பத்தனம்த்திட்டா (Pathanamthitta)" },
        { value: "Thiruvananthapuram", label: "திருவனந்தபுரம் (Thiruvananthapuram)" },
        { value: "Thrissur", label: "திருச்சூர் (Thrissur)" },
        { value: "Wayanad", label: "வயநாடு (Wayanad)" }
    ],


    "Karnataka": [
        { value: "Bagalkot", label: "பாகலகோட் (Bagalkot)" },
        { value: "Ballari", label: "பல்லாரி (Ballari)" },
        { value: "Belagavi", label: "பெள்காவி (Belagavi)" },
        { value: "Bengaluru", label: "பெங்களூரு (Bengaluru)" },
        { value: "Bengaluru Rural", label: "பெங்களூரு கிராமம் (Bengaluru Rural)" },
        { value: "Bidar", label: "பீதர் (Bidar)" },
        { value: "Chamarajanagar", label: "சாமராஜநகர் (Chamarajanagar)" },
        { value: "Chikkaballapur", label: "சிக்கபலாப்பூர் (Chikkaballapur)" },
        { value: "Chikkamagaluru", label: "சிக்கமகளூர் (Chikkamagaluru)" },
        { value: "Chitradurga", label: "சித்ரதுர்கா (Chitradurga)" },
        { value: "Dakshina Kannada", label: "தெற்கு கன்னடா (Dakshina Kannada)" },
        { value: "Davanagere", label: "தவனகேரே (Davanagere)" },
        { value: "Dharwad", label: "தர்வாட் (Dharwad)" },
        { value: "Gadag", label: "காடாக் (Gadag)" },
        { value: "Hassan", label: "ஹஸன் (Hassan)" },
        { value: "Haveri", label: "ஹாவேரி (Haveri)" },
        { value: "Kalaburagi", label: "கலபுரகி (Kalaburagi)" },
        { value: "Kodagu", label: "கொடகு (Kodagu)" },
        { value: "Kolar", label: "கோலார் (Kolar)" },
        { value: "Koppal", label: "கோப்பட்டி (Koppal)" },
        { value: "Mandya", label: "மாண்ட்யா (Mandya)" },
        { value: "Mysuru", label: "மைசூரு (Mysuru)" },
        { value: "Raichur", label: "ரைச்சூர் (Raichur)" },
        { value: "Ramanagara", label: "ராமநகரா (Ramanagara)" },
        { value: "Shivamogga", label: "சிவமொக்கா (Shivamogga)" },
        { value: "Tumakuru", label: "துமக்கூர் (Tumakuru)" },
        { value: "Udupi", label: "உடுப்பி (Udupi)" },
        { value: "Uttara Kannada", label: "வடக்கு கன்னடா (Uttara Kannada)" },
        { value: "Vijayapura", label: "விஜயபுரா (Vijayapura)" },
        { value: "Yadgir", label: "யாத்கீர் (Yadgir)" }
    ],


    "Andhra Pradesh": [
        { value: "Anantapur", label: "அனந்தபூர் (Anantapur)" },
        { value: "Chittoor", label: "சித்தூர் (Chittoor)" },
        { value: "East Godavari", label: "கிழக்கு கோதாவரி (East Godavari)" },
        { value: "Guntur", label: "குந்தூர் (Guntur)" },
        { value: "Krishna", label: "கிருஷ்ணா (Krishna)" },
        { value: "Kurnool", label: "கூர்னூல் (Kurnool)" },
        { value: "Prakasam", label: "பிரகாசம் (Prakasam)" },
        { value: "Srikakulam", label: "சிருகாகுலம் (Srikakulam)" },
        { value: "Visakhapatnam", label: "விசாகப்பட்டினம் (Visakhapatnam)" },
        { value: "Vizianagaram", label: "விழியநகரம் (Vizianagaram)" },
        { value: "West Godavari", label: "மேற்கு கோதாவரி (West Godavari)" },
        { value: "YSR Kadapa", label: "கடப்பா (YSR Kadapa)" }
    ],


    // 🎯 UNION TERRITORIES

    "Puducherry": [
        { value: "Pondicherry", label: "புதுச்சேரி (Pondicherry)" },
        { value: "Karaikal", label: "காரைக்கால் (Karaikal)" },
        { value: "Mahe", label: "மாயி (Mahe)" },
        { value: "Yanam", label: "யானம் (Yanam)" }
    ],

    /*"Delhi": [
        { value: "Central Delhi", label: "சென்ட்ரல் டெல்லி (Central Delhi)" },
        { value: "East Delhi", label: "கிழக்கு டெல்லி (East Delhi)" },
        { value: "New Delhi", label: "புதிய டெல்லி (New Delhi)" },
        { value: "North Delhi", label: "வட டெல்லி (North Delhi)" },
        { value: "North East Delhi", label: "வடகிழக்கு டெல்லி (North East Delhi)" },
        { value: "North West Delhi", label: "வடமேற்கு டெல்லி (North West Delhi)" },
        { value: "Shahdara", label: "ஷாக்தரா (Shahdara)" },
        { value: "South Delhi", label: "தென் டெல்லி (South Delhi)" },
        { value: "South East Delhi", label: "தென்கிழக்கு டெல்லி (South East Delhi)" },
        { value: "South West Delhi", label: "தென்மேற்கு டெல்லி (South West Delhi)" },
        { value: "West Delhi", label: "மேற்கு டெல்லி (West Delhi)" }
    ],


    "Jammu and Kashmir": [
        { value: "Anantnag", label: "அனந்த்நாக் (Anantnag)" },
        { value: "Bandipora", label: "பந்திப்போரா (Bandipora)" },
        { value: "Baramulla", label: "பாராமுல்லா (Baramulla)" },
        { value: "Budgam", label: "புட்காம் (Budgam)" },
        { value: "Doda", label: "டோடா (Doda)" },
        { value: "Ganderbal", label: "கண்டர்பால் (Ganderbal)" },
        { value: "Jammu", label: "ஜம்மு (Jammu)" },
        { value: "Kathua", label: "கத்துவா (Kathua)" },
        { value: "Kishtwar", label: "கிஷ்த்வார் (Kishtwar)" },
        { value: "Kulgam", label: "குல்காம் (Kulgam)" },
        { value: "Kupwara", label: "குப்வாரா (Kupwara)" },
        { value: "Poonch", label: "பூஞ்ச் (Poonch)" },
        { value: "Pulwama", label: "புல்வாமா (Pulwama)" },
        { value: "Rajouri", label: "ராஜௌரி (Rajouri)" },
        { value: "Ramban", label: "ராம்பன் (Ramban)" },
        { value: "Reasi", label: "ரியாஸி (Reasi)" },
        { value: "Samba", label: "சம்பா (Samba)" },
        { value: "Shopian", label: "ஷோபியான் (Shopian)" },
        { value: "Srinagar", label: "ஸ்ரீநகர் (Srinagar)" },
        { value: "Udhampur", label: "உதம்பூர் (Udhampur)" }
    ],


    "Ladakh": [
        { value: "Kargil", label: "கார்கில் (Kargil)" },
        { value: "Leh", label: "லே (Leh)" }
    ],

    "Chandigarh": [
        { value: "Chandigarh", label: "சண்டிகர் (Chandigarh)" }
    ],

    "Lakshadweep": [
        { value: "Lakshadweep", label: "லட்சத்தீவு (Lakshadweep)" }
    ],


    "Dadra and Nagar Haveli and Daman and Diu": [
        { value: "Dadra & Nagar Haveli", label: "தாத்ரா & நகர் ஹவேலி (Dadra & Nagar Haveli)" },
        { value: "Daman", label: "தாமன் (Daman)" },
        { value: "Diu", label: "தியூ (Diu)" }
    ],


    "Andaman and Nicobar Islands": [
        { value: "Nicobar", label: "நிக்கோபார் (Nicobar)" },
        { value: "North and Middle Andaman", label: "வட & நடு அந்தமான் (North and Middle Andaman)" },
        { value: "South Andaman", label: "தென் அந்தமான் (South Andaman)" }
    ]*/
};
